import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import BasePage from './pages/BasePage';
import BaseAdmin from './admin/BaseAdmin';

function App() {
  return (
    <Router>
        <Routes>
          <Route path="/*" element={<BasePage />} />
          <Route path="/admin/*" element={<BaseAdmin />}/>
        </Routes>
    </Router>
  );
}

export default App;